import Http from '../http';

const prefix = '/integrations';

export const getVideoHosting = () => {
  return Http.authApi().get(`${prefix}/video-hosting`);
};



// WEBPACK FOOTER //
// ./src/js/services/editor/integrations.js